export const toUsersSelect = users =>
  users.map(user => ({
    value: user.id,
    label: user.firstName + ' ' + user.lastName,
    teams: user.teams,
    type: 'users'
  }))

export const toContactsSelect = contacts =>
  contacts.map(contact => ({
    label: `${contact.firstName} ${contact.lastName}`,
    value: contact.id,
    type: 'contacts'
  }))
